export const ELEMENT_IDS = {
  menuHeader: {
    title: 'menu-header',
    column: 'column',
    link: 'link',
    teaser: 'teaser',
  },
  metaHeader: {
    title: 'meta-header',
    locations: 'locations',
    watchlist: 'watchlist',
    logo: 'logo',
  },
  metaFooter: {
    title: 'meta-footer',
    cookieSettings: 'cookie-settings',
    cookiePolicy: 'cookie-policy',
    imprint: 'imprint',
    privacyPolicy: 'privacy-policy',
  },
  menuFooter: {
    title: 'menu-footer',
    link: 'link',
  },
};

export const PROD_ENV_URL = 'https://www.engelvoelkers.com';
